import { ComposeSnapshotSyncBlockedReason } from '../../enums/composeSnapshotSyncBlockedReason';

export const SYNC_BLOCKED_REASON_I18N_KEYS: Record<
  ComposeSnapshotSyncBlockedReason,
  string
> = {
  [ComposeSnapshotSyncBlockedReason.CONFLICT]:
    'inbox.userCommunication.localDrafts.syncBlocked.CONFLICT',
  [ComposeSnapshotSyncBlockedReason.NOT_FOUND]:
    'inbox.userCommunication.localDrafts.syncBlocked.NOT_FOUND',
  [ComposeSnapshotSyncBlockedReason.PAYLOAD_TOO_LARGE]:
    'inbox.userCommunication.localDrafts.syncBlocked.PAYLOAD_TOO_LARGE',
};
